var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "@babel/runtime-corejs2/helpers/defineProperty", "@babel/runtime-corejs2/helpers/objectWithoutProperties", "core-js/modules/es6.array.find", "date-fns", "./teaser/fromEmacTeaser", "./teaser/fromEmacProgram", "./custom/programToTeaserVideo", "@date-fns/upgrade/v2"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("@babel/runtime-corejs2/helpers/objectWithoutProperties"), require("core-js/modules/es6.array.find"), require("date-fns"), require("./teaser/fromEmacTeaser"), require("./teaser/fromEmacProgram"), require("./custom/programToTeaserVideo"), require("@date-fns/upgrade/v2"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.defineProperty, global.objectWithoutProperties, global.es6Array, global.dateFns, global.fromEmacTeaser, global.fromEmacProgram, global.programToTeaserVideo, global.v2);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _defineProperty3, _objectWithoutProperties2, _es6Array, _dateFns, _fromEmacTeaser, _fromEmacProgram, _programToTeaserVideo, _v) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.teaserVideoFromProgram = _exports.dataToTeaserFromType = _exports.getPlayIcon = _exports.getWarning = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _fromEmacTeaser = _interopRequireDefault(_fromEmacTeaser);
  _fromEmacProgram = _interopRequireDefault(_fromEmacProgram);
  _programToTeaserVideo = _interopRequireDefault(_programToTeaserVideo);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  var getWarning = function getWarning(_ref) {
    var stickers = _ref.stickers;
    var warningSticker = stickers && stickers.find(function (s) {
      return s.code === '-16' || s.code === '-18';
    });
    return warningSticker ? warningSticker.code : null;
  };

  _exports.getWarning = getWarning;

  var getPlayIcon = function getPlayIcon(_ref2) {
    var availability = _ref2.availability,
        kind = _ref2.kind;

    if (kind && kind.code === 'SHOW') {
      return true;
    }

    if (!availability || !(0, _dateFns.isValid)((0, _v.legacyParse)(new Date(availability.upcomingDate)))) {
      return false;
    }

    return availability.type === 'VOD' && (0, _dateFns.isBefore)((0, _v.legacyParse)(availability.upcomingDate), (0, _v.legacyParse)(new Date()));
  };

  _exports.getPlayIcon = getPlayIcon;

  var dataToTeaserFromType = function dataToTeaserFromType(translate) {
    var transformers = {
      program: (0, _fromEmacProgram.default)(translate),
      teaser: (0, _fromEmacTeaser.default)(translate),
      collection: null // Useless for the moment

    };
    return function (_ref3) {
      var type = _ref3.type,
          item = (0, _objectWithoutProperties2.default)(_ref3, ["type"]);
      var transformer = transformers[type];
      var teaser = transformer && transformer(item);
      return teaser && _objectSpread(_objectSpread({}, teaser), {}, {
        playIcon: getPlayIcon(item),
        warning: getWarning(teaser),
        // needed by ASG TeaserShow
        markings: [] // needed by ASG TeaserShow

      });
    };
  };

  _exports.dataToTeaserFromType = dataToTeaserFromType;
  var teaserVideoFromProgram = _programToTeaserVideo.default;
  _exports.teaserVideoFromProgram = teaserVideoFromProgram;
});